import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/_services/data.service';

@Component({
  selector: 'app-voice-navigation',
  templateUrl: './voice-navigation.component.html',
  styleUrls: ['./voice-navigation.component.css']
})
export class VoiceNavigationComponent implements OnInit {
  recognition: any;
  listening: boolean = false;
  transcript: string = '';
  compId: string = '';
  projUid: string = '';

  constructor(
    public dataService: DataService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.compId = this.route.snapshot.firstChild.params.id;
    this.projUid = this.route.snapshot.firstChild.params.idp;
  }

  ngOnInit(): void {
    this.initializeSpeechRecognition();
  }


  // Initialize the Web Speech API with Hebrew support
  initializeSpeechRecognition(): void {
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (SpeechRecognition) {
      this.recognition = new SpeechRecognition();
      this.recognition.continuous = false; // Stops after each command
      this.recognition.interimResults = false; // Final results only
      this.recognition.lang = 'he-IL'; // Set language to Hebrew (Israel)

      // When speech recognition detects a result
      this.recognition.onresult = (event: any) => {
        const lastResult = event.results[event.results.length - 1];
        this.transcript = lastResult[0].transcript.trim();
        this.handleVoiceCommand(this.transcript);
        // Stop the recognition after command is processed
        this.recognition.stop();
        this.listening = false;
      };

      // Handle errors
      this.recognition.onerror = (event: any) => {
        console.error('Speech recognition error detected: ' + event.error);
        this.listening = false;
      };

      this.recognition.onend = () => {
        this.listening = false;
      };
    } else {
      console.warn('Web Speech API is not supported in this browser.');
    }
  }

  // Start listening for voice input
  startListening(): void {
    if (this.recognition && !this.listening) {
      this.recognition.start();
      this.listening = true;
    }
  }

  // Handle recognized voice command
  handleVoiceCommand(command: string): void {
    // Log the Hebrew command for debugging
    console.log('Recognized Hebrew command:', command);

    // Example: Handle Hebrew navigation commands
    if (command.includes('בית')) {  // "בית" means "Home" in Hebrew
      // window.location.href = '/home';
      this.router.navigate(['/company/u/' + this.compId + '/' + this.projUid]);
    } else if (command.includes('תציג מפה')) {  // "אודות" means "About"
      
      this.router.navigate(['/company/u/' + this.compId + '/' + this.projUid +'/nearbyProject']);
      // window.location.href = '/about';
    } else if (command.includes('צור קשר')) {  // "צור קשר" means "Contact"
      window.location.href = '/contact';
    } else {
      console.log('Unrecognized command:', command);
    }
  }
}
